import type { CSSProperties } from 'react';

import CreateAgreementModal from './CreateAgreementModal';

type Props = {
    open: boolean;
    onClose: () => void;
    modalStyle?: CSSProperties;
    wrapperStyle?: CSSProperties;
    contentStyle?: CSSProperties;
    maxWidth?: string;
};

export default function CreateAgreementModalWrapper({ open, onClose }: Props) {
    if (!open) {
        return null;
    }

    return <CreateAgreementModal onClose={onClose} />;
}
